module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.options) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "form-group-label"
  }, [_vm._v("Data Overwrite Options")]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.overwriteOptions),
      expression: "options.overwriteOptions"
    }],
    attrs: {
      "type": "radio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.options.overwriteOptions, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.options, "overwriteOptions", "0")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Overwrite existing data")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.overwriteOptions),
      expression: "options.overwriteOptions"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.options.overwriteOptions, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.options, "overwriteOptions", "1")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Do not overwrite")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.overwriteOptions),
      expression: "options.overwriteOptions"
    }],
    attrs: {
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.options.overwriteOptions, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.options, "overwriteOptions", "2")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Append")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onOkClick()
      }
    }
  }, [_vm._v("Publish")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onCancelClick()
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4c7dd61a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c7dd61a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/publish-to-dashboard-options/publish-to-dashboard-options.vue.html
// module id = 1102
// module chunks = 0